import { memo, type FC } from "react";
import dayjs, { type Dayjs } from "dayjs";
import { DashboardAntDatePicker } from "src/components/reusable/AntdDatePicker/DashboardAntDatePicker";
import {
  DATE_DISPLAY_FORMAT,
  DATE_VALUE_FORMAT,
  SIGNUP_OPERATORS,
  type SignupDateCondition,
  type SignupOperator,
} from "../../CreateSegment.Constants";
import { useSegmentLabel, useSegmentOptions } from "../../UseSegmentLabel";
import { ConditionFieldsRow, SegmentSelect, type ConditionFieldsProps } from "../ConditionControls";

const SignupDateFields: FC<ConditionFieldsProps<SignupDateCondition>> = ({ condition, onChange }) => {
  const label = useSegmentLabel();
  const operatorOptions = useSegmentOptions("fields.signupDate.operators", SIGNUP_OPERATORS);

  return (
    <ConditionFieldsRow label={label("fields.signupDate.label")}>
      <SegmentSelect
        className="segment-builder__control--date-operator"
        aria-label={label("fields.signupDate.operatorAria")}
        value={condition.operator}
        options={operatorOptions}
        onChange={(operator: SignupOperator) => onChange({ ...condition, operator })}
      />
      <DashboardAntDatePicker
        className="segment-builder__date"
        aria-label={label("fields.signupDate.dateAria")}
        value={condition.date ? dayjs(condition.date) : null}
        format={DATE_DISPLAY_FORMAT}
        placeholder={label("fields.signupDate.placeholder")}
        allowClear={false}
        onChange={(date: Dayjs | null) =>
          onChange({ ...condition, date: date ? date.format(DATE_VALUE_FORMAT) : null })
        }
      />
    </ConditionFieldsRow>
  );
};

export default memo(SignupDateFields);
